[
  {
    "id": "GET-B7-L4-001",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Een jas kost € 80,-. In de uitverkoop krijg je 25% korting. Wat betaal je?",
    "options": [
      "€ 60,-",
      "€ 55,-",
      "€ 50,-",
      "€ 45,-"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-KORTING",
    "explanation": "25% korting betekent dat je 75% betaalt. 75% van 80 is 60 euro.",
    "distractorExplanations": {
      "1": "Je haalde 25 euro af in plaats van 25% (dat is 20 euro).",
      "2": "Je nam 50% korting, maar het is 25%.",
      "3": "Je haalde 35 euro af, maar 25% van 80 is 20 euro."
    }
  },
  {
    "id": "GET-B7-L4-002",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "40% van 250 is ...",
    "options": [
      "90",
      "100",
      "110",
      "120"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-TOETS",
    "explanation": "40% is 4 keer 10%. 10% van 250 is 25, dus 4 × 25 = 100.",
    "distractorExplanations": {
      "0": "Dit is 36% van 250. 40% is iets meer.",
      "2": "Je nam 44% in plaats van 40%.",
      "3": "Je vermenigvuldigde 4 met 30 in plaats van met 25."
    }
  },
  {
    "id": "GET-AFT-L3-001",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Reken uit: 503 - 248 =",
    "options": [
      "255",
      "265",
      "245",
      "345"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-DOOR-NUL",
    "explanation": "Let op de 0! 3 - 8 kan niet, leen van 0. Maar 0 heeft niks, dus leen van 5. Nu: 13 - 8 = 5, 9 - 4 = 5, 4 - 2 = 2. Dus 255.",
    "distractorExplanations": {
      "1": "Rekenfout bij het lenen door de 0 heen.",
      "2": "Je hebt verkeerd geleend. Let op de 0!",
      "3": "Te veel afgetrokken. Check je lenen stap voor stap."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Lenen door een 0",
        "content": "Als er een 0 staat, moet je verder lenen! De 0 wordt 9, en je leent van het cijfer ervoor.",
        "icon": "alert"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-AFT-L3-002",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Reken uit: 1.000 - 387 =",
    "options": [
      "613",
      "713",
      "623",
      "513"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-DOOR-NUL",
    "explanation": "1000 - 387: Leen door alle nullen! 10 - 7 = 3, 9 - 8 = 1, 9 - 3 = 6. Dus 613.",
    "distractorExplanations": {
      "1": "Je leende niet goed door de nullen. Bij de honderdtallen: 9 - 3 = 6, niet 7. Controleer elke kolom.",
      "2": "Je verwisselde de tientallen. Na het lenen wordt het 9 - 8 = 1, niet 2.",
      "3": "Je trok te veel af bij de honderdtallen. Na het lenen: 9 - 3 = 6, niet 5."
    }
  },
  {
    "id": "GET-AFT-L3-003",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Reken uit: 2.004 - 1.568 =",
    "options": [
      "436",
      "536",
      "446",
      "546"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-DOOR-NUL",
    "explanation": "2004 - 1568: Leen waar nodig. 14 - 8 = 6, 9 - 6 = 3, 9 - 5 = 4, 1 - 1 = 0. Dus 436.",
    "distractorExplanations": {
      "1": "Je leende niet goed bij de honderdtallen. Na het lenen door de 0: 9 - 5 = 4, niet 5.",
      "2": "Je maakte een fout bij de tientallen. Na het lenen: 9 - 6 = 3, niet 4.",
      "3": "Je combineerde fouten bij de honderdtallen en tientallen. Werk kolom voor kolom: 14-8=6, 9-6=3, 9-5=4, 1-1=0."
    }
  },
  {
    "id": "GET-VGL-L3-001",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Welke breuk ligt precies tussen $\\frac{1}{4}$ en $\\frac{1}{2}$?",
    "options": [
      "$\\frac{3}{8}$",
      "$\\frac{2}{6}$",
      "$\\frac{1}{3}$",
      "$\\frac{2}{5}$"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_vergelijken",
    "familyId": "GET-BREUK-VGL",
    "explanation": "$\\frac{3}{8}$ ligt precies tussen $\\frac{1}{4}$ en $\\frac{1}{2}$. Maak gelijk: $\\frac{1}{4}$ = $\\frac{2}{8}$ en $\\frac{1}{2}$ = $\\frac{4}{8}$. Dus $\\frac{3}{8}$ zit ertussen!",
    "distractorExplanations": {
      "1": "$\\frac{2}{6}$ = $\\frac{1}{3}$, dat is iets te groot.",
      "2": "$\\frac{1}{3}$ ligt er iets boven.",
      "3": "$\\frac{2}{5}$ ligt er ook niet precies tussen."
    }
  },
  {
    "id": "GET-CONTEXT-L3-001",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Ze geeft 15 knikkers weg aan haar vriendin. Hoeveel knikkers heeft Lisa nu nog?",
    "options": [
      "57 knikkers",
      "72 knikkers",
      "87 knikkers",
      "42 knikkers"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "meerstaps",
    "familyId": "GET-MEERSTAPS",
    "context": "Lisa heeft 3 zakken met knikkers. In de eerste zak zitten 24 knikkers, in de tweede zak 18 knikkers en in de derde zak 30 knikkers.",
    "explanation": "Eerst tel je alle knikkers op: 24 + 18 + 30 = 72 knikkers.\nDan trek je de weggegeven knikkers eraf: 72 - 15 = 57 knikkers.",
    "distractorExplanations": {
      "1": "Je hebt alleen de eerste twee zakken opgeteld. Tel alle drie de zakken op!",
      "2": "Dit is het totaal aantal knikkers. Maar Lisa geeft er 15 weg!",
      "3": "Je hebt verkeerd gerekend. Check: 24 + 18 + 30 = 72, dan 72 - 15 = 57."
    }
  },
  {
    "id": "GET-PROC-L4-003",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Een broek kost € 120,-. Er is 30% korting. Wat betaal je?",
    "options": [
      "€ 84,-",
      "€ 90,-",
      "€ 96,-",
      "€ 100,-"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-KORTING",
    "explanation": "30% korting betekent 70% betalen. 70% van 120 is 84.",
    "distractorExplanations": {
      "1": "Je nam 25% korting, maar het is 30%.",
      "2": "Je haalde 24 euro af (20%), maar 30% is 36 euro.",
      "3": "Je hield 100 euro over, dat is te weinig korting."
    }
  },
  {
    "id": "GET-PROC-L4-004",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Op een jas komt 15% btw. De prijs zonder btw is € 200,-. Wat is de prijs met btw?",
    "options": [
      "€ 230,-",
      "€ 215,-",
      "€ 240,-",
      "€ 260,-"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-BTW",
    "explanation": "15% van 200 is 30. Tel dat bij 200 op: 230.",
    "distractorExplanations": {
      "1": "Je nam 7,5% in plaats van 15%.",
      "2": "Je nam 20% btw. Dat is te veel.",
      "3": "Je telde 60 euro erbij, dat is 30% btw."
    }
  },
  {
    "id": "GET-VERH-L4-001",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Op een kaart is de schaal 1 : 50.000. Een afstand van 3 cm op de kaart is in het echt ...",
    "options": [
      "1,5 km",
      "150 m",
      "3 km",
      "15 km"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-SCHAAL",
    "explanation": "1 cm is 50.000 cm = 500 m = 0,5 km. 3 cm is 3 × 0,5 km = 1,5 km.",
    "distractorExplanations": {
      "1": "Je rekende 1 cm als 50 m, maar het is 500 m.",
      "2": "Je rekende 1 cm als 1 km, maar het is 0,5 km.",
      "3": "Je vermenigvuldigde de km te groot."
    }
  },
  {
    "id": "GET-BREUK-L4-001",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Welke breuk is groter: $\\frac{7}{12}$ of $\\frac{5}{8}$?",
    "options": [
      "$\\frac{7}{12}$",
      "$\\frac{5}{8}$",
      "Ze zijn even groot",
      "Niet te zeggen"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_vergelijken",
    "familyId": "GET-BREUK-VGL",
    "explanation": "Maak gelijknamig: $\\frac{7}{12} = \\frac{14}{24}$ en $\\frac{5}{8} = \\frac{15}{24}$. 15/24 is groter.",
    "distractorExplanations": {
      "0": "Na gelijknamig maken zie je dat 14/24 kleiner is dan 15/24.",
      "2": "Ze zijn niet gelijk: 15/24 is groter dan 14/24.",
      "3": "Je kunt het wel vergelijken door gelijknamig te maken."
    }
  },
  {
    "id": "GET-DEC-L4-001",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Reken uit: 6,5 - 2,78 =",
    "options": [
      "3,72",
      "3,82",
      "3,28",
      "4,12"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "decimalen",
    "familyId": "GET-KOMMA-AFTREKKEN",
    "explanation": "Schrijf 6,50 - 2,78. Dan 50 - 78 kan niet, dus leen: 150 - 78 = 72 en 5 - 2 - 1 = 3. Dus 3,72.",
    "distractorExplanations": {
      "1": "Je leende niet bij de honderdsten.",
      "2": "Je trok 2,78 af van 5,5 in plaats van van 6,5.",
      "3": "Je zette de komma verkeerd."
    }
  },
  {
    "id": "GET-MEERSTAPS-L4-002",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Drie schriften kosten € 2,35 per stuk. Je betaalt met € 10,-. Hoeveel wisselgeld krijg je?",
    "options": [
      "€ 2,95",
      "€ 3,05",
      "€ 4,05",
      "€ 1,95"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "meerstaps",
    "familyId": "GET-MEERSTAPS",
    "explanation": "3 × 2,35 = 7,05. Wisselgeld: 10,00 - 7,05 = 2,95.",
    "distractorExplanations": {
      "1": "Je vermenigvuldigde 2,35 met 2 in plaats van 3.",
      "2": "Je haalde 6,95 af in plaats van 7,05.",
      "3": "Je nam 8,05 als totaalbedrag, maar dat klopt niet."
    }
  },
  {
    "id": "GET-PROC-L4-005",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "60% van 450 is ...",
    "options": [
      "270",
      "240",
      "300",
      "260"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-BEREKENEN",
    "explanation": "10% van 450 is 45. 60% is 6 × 45 = 270.",
    "distractorExplanations": {
      "1": "Je nam 50% (225) en telde verkeerd op.",
      "2": "Je nam 2/3 van 450, maar 60% is minder.",
      "3": "Je berekende 58% in plaats van 60%."
    }
  },
  {
    "id": "GET-VERH-L4-002",
    "module": "Getalbegrip",
    "difficulty": 201,
    "question": "Voor 4 personen heb je 250 g rijst nodig. Hoeveel rijst heb je nodig voor 6 personen?",
    "options": [
      "375 g",
      "300 g",
      "350 g",
      "400 g"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-VERHOUDING",
    "explanation": "6 is 1,5 keer zoveel als 4. 250 × 1,5 = 375 g.",
    "distractorExplanations": {
      "1": "Je rekende +50 g in plaats van ×1,5.",
      "2": "Je nam 5 personen als basis in plaats van 4.",
      "3": "Je rondde te hoog af."
    }
  }
]